import React from "react";
import "./android-ios.modal.sass";
import { Modal, Button, Icon, Row, Col, Alert } from "rsuite";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectInitModal } from "../../redux/modals/modals.selector";
import modalsTypes from "../../redux/modals/modals.types";
import {
  selectFirstCheck,
  selectIosAndroid,
} from "../../redux/user/user.selector";
import Logo from "../../assets/image/logo310.png";
import Iaps from "../../assets/image/iaps.png";
import Bazar from "../../assets/image/cafebazzar.png";
import addIcon from "../../assets/icons/add.svg";
import expert from "../../assets/icons/export.svg";
import Menu from "../../assets/icons/menu.svg";

const AndroidIosModal = ({ initModal, toggleInitModal, Device }) => {
  const ListItem = ({ number, title, img, text }) => {
    return (
      <div className="ios-body-item">
        <Row>
          <Col xs={21}>
            <p>
              <span>{number} - </span>
              <span>{title}</span>
            </p>
          </Col>
          <Col xs={3}>
            <div style={{ textAlign: "center" }}>
              {img ? <img src={img} alt="" /> : <strong>{text}</strong>}
            </div>
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <div>
      {Device === "ios" ? (
        <Modal
          size="xs"
          show={initModal}
          onHide={toggleInitModal}
          className="iosModal"
        >
          <Modal.Header>
            <div className="ios-header-image">
              <img src={Logo} alt="xitonix" /> <br />
            </div>
            <strong>
              جهت استفاده از وب‌اپلیکیشن زیتونیکس لطفا آن را به صفحه اصلی مبایل
              خود اضافه کنید.
            </strong>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "unset !important" }}>
            <div className="ios-body-list">
              <ListItem
                title={"نوار پایین دکمه share لمس کنید."}
                number={"۱"}
                img={expert}
              />
              <ListItem
                title={
                  "در منوی باز شده در قسمت پایین گزینه Add to Home Screen را انتخاب کنید."
                }
                number={"۲"}
                img={addIcon}
              />
              <ListItem
                title={"در مرحله بعد در قسمت بالا روی Add کلیک کنید."}
                number={"۳"}
                text="Add"
              />
            </div>
            <div className="ios-body-apps">
              <p>
                جهت تجربه لذت بخش میتوانید اپلیکیشن زیتونیکس را از این استور نصب
                کنید.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
              <Row>
                  <Col xs={12}>
            <Button block onClick={() => toggleInitModal()}>
              متوجه شدم
            </Button>
                  </Col>
                  <Col xs={12}>
            <Button
              block
              onClick={() =>
                window.open("https://xitonix.com/download", "_blank")
              }
              appearance="primary"
            >
              دانلود اپلیکیشن
            </Button>

                  </Col>
              </Row>
          </Modal.Footer>
        </Modal>
      ) : (
        // IF ANDROID
        <Modal
          size="xs"
          show={initModal}
          onHide={toggleInitModal}
          className="iosModal"
        >
          <Modal.Header>
            <div className="ios-header-image">
              <img src={Logo} alt="xitonix" /> <br />
            </div>
            <strong className="title-strong">
              جهت استفاده از وب‌اپلیکیشن زیتونیکس لطفا آن را به صفحه اصلی موبایل
              خود اضافه کنید.
            </strong>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "unset !important" }}>
            <div className="ios-body-list">
              <ListItem
                title={
                  "آیکن سه نقطه را از گوشه بالای سمت راست مروگر خود کلیک کنید."
                }
                number={"۱"}
                img={Menu}
              />
              <ListItem
                title={
                  "در منوی باز شده در قسمت پایین گزینه Addto Home Screen را انتخاب کنید."
                }
                number={"۲"}
                img={addIcon}
              />
              <ListItem
                title={"در مرحله بعد در قسمت بالا روی Add کلیک کنید."}
                number={"۳"}
                text={"Add"}
              />
            </div>
            <div className="ios-body-apps">
              <p>
                جهت تجربه لذت بخش میتوانید اپلیکیشن زیتونیکس را از این استور نصب
                کنید.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Row>
              <Col xs={12}>
                <Button
                  block
                  onClick={() => toggleInitModal()}
                >
                  متوجه شدم
                </Button>
              </Col>
              <Col xs={12}>
                <Button
                  block
                  onClick={() =>
                    window.open("https://xitonix.com/download", "_blank")
                  }
                  appearance="primary"
                >
                  دانلود اپلیکیشن
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  initModal: selectInitModal,
  Device: selectIosAndroid,
});
const mapDispatchToProps = (dispatch) => ({
  toggleInitModal: () => dispatch({ type: modalsTypes.TOGGLE_INIT_MODAL }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AndroidIosModal);
